import { css } from '@emotion/react';

import type { HTMLDataAttributes } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PageWrapperProps extends HTMLDataAttributes, React.HTMLAttributes<HTMLDivElement> {}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, ...props }) => {
  return (
    <div
      css={css({
        paddingLeft: 16,
        paddingRight: 16,
      })}
      {...props}
    >
      {children}
    </div>
  );
};
